<template>
  <ContentPage back>
    <template #header>
      <content-page-title>
        Successful Payment
      </content-page-title>
    </template>

    <Section class="d-flex flex-column" style="font-size: 16px;">
      <div class="d-flex">
        <div>Payment Date</div>
        <div class="ml-auto">{{ formatDate(payment.payment_date) }}</div>
      </div>
      
      <div class="d-flex mt-4">
        <div>Payment Amount:</div>
        <div class="ml-auto">{{ formatCurrency(payment.deposit_cents) }}</div>
      </div>
      
      <div class="d-flex my-1">
        <div>Transaction Fees:</div>
        <div class="ml-auto">{{ formatCurrency(payment.fees_reserved_cents) }}</div>
      </div>

      <v-divider/>
      
      <div class="d-flex mt-1">
        <div>Total:</div>
        <div class="ml-auto">{{ formatCurrency(payment.collected_cents) }}</div>
      </div>
      
    </Section>
  </ContentPage>
</template>

<script>

import formatters from '@/lib/formatters'
import { ContentPage, ContentPageTitle, Section } from '@/components/pages'

export default {
  name: "SuccessfulPayment",

  props: {
    payment: {
      type: Object,
      required: true,
    },
  },

  components: { ContentPage, ContentPageTitle, Section },

  methods: {
    ...formatters,
  },
}
</script>